import React from "react";
import { Users, Smartphone, Building2 } from "lucide-react";
import { calculatePercent } from '../../../../services/service';
import logoMbbank from '../../../../icons/logo-mbbank-4.png';

const SummaryStats = ({ summary }) => {
  // Destructuring các giá trị từ summary (đảm bảo fallback là 0)
  const {
    totalCustomers = 0,
    totalWithPhone = 0,
    totalMB = 0,
    totalOther = 0,
    totalWithMBPhone = 0,
    totalWithOtherPhone = 0
  } = summary || {};

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-8">
      {/* 1. Card Tổng số Khách hàng */}
      <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl p-5 text-white shadow-lg shadow-blue-200">
        <div className="flex justify-between items-start mb-4">
          <div>
            <p className="text-blue-100 text-sm font-medium mb-1">
              Tổng số Khách hàng
            </p>
            <h3 className="text-3xl font-bold">
              {totalCustomers.toLocaleString()}
            </h3>
          </div>
          <div className="p-2 bg-white/20 rounded-lg backdrop-blur-sm">
            <Users size={20} className="text-white" />
          </div>
        </div>
        <div className="text-blue-100 text-xs">Tất cả bản ghi hiển thị</div>
      </div>

      {/* 2. Card Khách hàng MB */}
      <div className="bg-white rounded-2xl p-5 border border-slate-100 shadow-sm hover:shadow-md transition-all">
        <div className="flex justify-between items-start mb-2">
          <div>
            <p className="text-slate-500 text-sm font-medium mb-1">
              Tài khoản MB
            </p>
            <h3 className="text-2xl font-bold text-indigo-600">
              {totalMB.toLocaleString()}
            </h3>
          </div>

          <div className="p-2 bg-blue-50 rounded-lg">
            <img
              src={logoMbbank}
              alt="MB Bank"
              className="w-5 h-5 object-contain"
            />
          </div>
        </div>
        <div className="w-full bg-slate-100 h-1.5 rounded-full overflow-hidden mt-2">
          <div
            className="bg-indigo-500 h-full rounded-full"
            style={{ width: `${calculatePercent(totalMB, totalCustomers)}%` }}
          ></div>
        </div>
        <p className="text-xs text-slate-400 mt-2">
          Chiếm{" "}
          <span className="font-semibold text-indigo-600">
            {calculatePercent(totalMB, totalCustomers)}%
          </span>{" "}
          thị phần
        </p>
      </div>

      {/* 3. Card Ngân hàng khác */}
      <div className="bg-white rounded-2xl p-5 border border-slate-100 shadow-sm hover:shadow-md transition-all">
        <div className="flex justify-between items-start mb-2">
          <div>
            <p className="text-slate-500 text-sm font-medium mb-1">
              Ngân hàng Khác
            </p>
            <h3 className="text-2xl font-bold text-orange-600">
              {totalOther.toLocaleString()}
            </h3>
          </div>
          <div className="p-2 bg-orange-50 text-orange-600 rounded-lg">
            <Building2 size={20} />
          </div>
        </div>
        <div className="w-full bg-slate-100 h-1.5 rounded-full overflow-hidden mt-2">
          <div
            className="bg-orange-500 h-full rounded-full"
            style={{
              width: `${calculatePercent(totalOther, totalCustomers)}%`,
            }}
          ></div>
        </div>
        <p className="text-xs text-slate-400 mt-2">
          Chiếm{" "}
          <span className="font-semibold text-orange-600">
            {calculatePercent(totalOther, totalCustomers)}%
          </span>{" "}
          thị phần
        </p>
      </div>

      {/* 4. Card Khách hàng có SĐT (Định danh) */}
      <div className="bg-white rounded-2xl p-5 border border-slate-100 shadow-sm hover:shadow-md transition-all">
        <div className="flex justify-between items-start mb-2">
          <div>
            <p className="text-slate-500 text-sm font-medium mb-1">
              KH có Số điện thoại
            </p>
            <h3 className="text-2xl font-bold text-emerald-600">
              {totalWithPhone.toLocaleString()}
            </h3>
          </div>
          <div className="p-2 bg-emerald-50 text-emerald-600 rounded-lg">
            <Smartphone size={20} />
          </div>
        </div>
        <div className="w-full bg-slate-100 h-1.5 rounded-full overflow-hidden mt-2">
          <div
            className="bg-emerald-500 h-full rounded-full"
            style={{
              width: `${calculatePercent(totalWithPhone, totalCustomers)}%`,
            }}
          ></div>
        </div>
        <p className="text-xs text-slate-400 mt-2">
          Chiếm{" "}
          <span className="font-semibold text-emerald-600">
            {calculatePercent(totalWithPhone, totalCustomers)}%
          </span>{" "}
          tổng KH
        </p>
      </div>

      {/* 5. Card Khách hàng có SĐT thuộc MB */}
      <div className="bg-white rounded-2xl p-5 border border-slate-100 shadow-sm hover:shadow-md transition-all">
        <div className="flex justify-between items-start mb-2">
          <div>
            <p className="text-slate-500 text-sm font-medium mb-1">
              KH có Số điện thoại và Tài khoản MB
            </p>
            <h3 className="text-2xl font-bold text-indigo-600">
              {totalWithMBPhone.toLocaleString()}
            </h3>
          </div>

          <div className="p-2 bg-blue-50 rounded-lg">
            <img
              src={logoMbbank}
              alt="MB Bank"
              className="w-5 h-5 object-contain"
            />
          </div>
        </div>
        <div className="w-full bg-slate-100 h-1.5 rounded-full overflow-hidden mt-2">
          <div
            className="bg-indigo-500 h-full rounded-full"
            style={{
              width: `${calculatePercent(totalWithMBPhone, totalCustomers)}%`,
            }}
          ></div>
        </div>
        <p className="text-xs text-slate-400 mt-2">
          Chiếm{" "}
          <span className="font-semibold text-indigo-600">
            {calculatePercent(totalWithMBPhone, totalCustomers)}%
          </span>{" "}
          tổng KH
        </p>
      </div>

      {/* 6. Card Khách hàng có SĐT thuộc NH khác */}
      <div className="bg-white rounded-2xl p-5 border border-slate-100 shadow-sm hover:shadow-md transition-all">
        <div className="flex justify-between items-start mb-2">
          <div>
            <p className="text-slate-500 text-sm font-medium mb-1">
              KH có Số điện thoại và Ngân hàng khác
            </p>
            <h3 className="text-2xl font-bold text-orange-600">
              {totalWithOtherPhone.toLocaleString()}
            </h3>
          </div>
          <div className="p-2 bg-orange-50 text-orange-600 rounded-lg">
            <Building2 size={20} />
          </div>
        </div>
        <div className="w-full bg-slate-100 h-1.5 rounded-full overflow-hidden mt-2">
          <div
            className="bg-orange-500 h-full rounded-full"
            style={{
              width: `${calculatePercent(totalWithOtherPhone, totalCustomers)}%`,
            }}
          ></div>
        </div>
        <p className="text-xs text-slate-400 mt-2">
          Chiếm{" "}
          <span className="font-semibold text-orange-600">
            {calculatePercent(totalWithOtherPhone, totalCustomers)}%
          </span>{" "}
          tổng KH
        </p>
      </div>
    </div>
  );
};

export default SummaryStats;
